
import React from 'react';
import { cn } from "@/lib/utils";
import { Button } from '@/components/ui/button';

interface NavigationItemProps {
  active: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
}

const NavigationItem = ({ active, onClick, icon, label }: NavigationItemProps) => {
  return (
    <Button
      variant="ghost"
      className={cn(
        "justify-start px-3 w-full text-left font-normal transition-colors duration-200", 
        active ? "bg-accent text-accent-foreground border-l-2 border-primary" : "hover:bg-accent/50"
      )}
      onClick={onClick}
    >
      {icon}
      {label}
    </Button>
  );
};

export default NavigationItem;
